<template>
	<div style="position: relative; width: 100%; height: 100%;">
		<div id="d006" class="diagram" style="padding-bottom: 3rem;"></div>
		<div
			class="center"
			style="position: absolute; bottom: 0; left: 0; right: 0;"
		>
			<span class="dot bcPrimary"></span> {{ 'Nettoomsättning' | T }}
			<span class="dot bcSecondary"></span> {{ 'Övriga intäkter' | T }}
			<span class="dot bcTertiary"></span> {{ 'Rörelsekostnader' | T }}
			<span class="dot bcLightGrey"></span> {{ 'Andra kostnader' | T }}
			<span class="dot result"></span> {{ 'Årets resultat' | T }}
		</div>
	</div>
</template>

<script>
/* tslint:disable */
import Highcharts from "highcharts";
import Vue from "vue";
import { colors } from "@/config";

export default {
	name: "D006",
	components: {},
	props: {
		profitloss: Object,
	},

	methods: {
		pos(val) {
			if (val < 0) return 0;
			return val;
		},
		neg(val) {
			if (val > 0) return 0;
			return -val;
		},
	},

	mounted() {
		this.chart = new Highcharts.chart({
			chart: {
				type: "column",
				renderTo: "d006",
				backgroundColor: "transparent",
			},

			credits: {
				enabled: false,
			},

			title: {
				text: "",
			},

			legend: {
				enabled: false,
			},

			colors: [
				...Array(9).fill(colors.Secondary),
				colors.Primary,
				...Array(2).fill(colors.LightGrey),
				...Array(5).fill(colors.Tertiary),
				...Array(3).fill(colors.LightGrey),
				colors.Green,
				colors.Red,
			],

			xAxis: {
				categories: this.profitloss.sheets.map((s) => s.DATE_TO.substr(0, 4)),
				labels: {
					style: { fontSize: "1rem", color: colors.Black, },
				},
				reversed: true,
				reversedStacks: true,
			},

			yAxis: {
				opposite: true,
				allowDecimals: false,
				title: {
					text: "",
				},
				labels: {
					formatter() {
						return Vue.options.filters.KR(this.value);
					},
					style: { fontSize: "1rem", color: colors.DarkGrey, },
				},
				tickPixelInterval: 150,
				gridLineColor: colors.LightGrey,
				plotLines: [{
					color: colors.Black,
					width: 2,
					value: 0,
					zIndex: 2,
				}],
			},

			tooltip: {
				formatter: function() {
					return (
						"<b>" +
						this.x +
						"</b><br/>" +
						this.series.name +
						": " +
						Vue.options.filters.TKR(this.y) +
						"<br/>"
					);
				},
				style: { fontSize: "1.25rem" },
				backgroundColor: colors.Light,
			},

			plotOptions: {
				column: {
					stacking: "normal",
					borderColor: "#5d5d5d",
				},
			},

			series: [
				{
					name: this.$t("Skatt"),
					data: this.profitloss.sheets.map((s) => this.pos(s.Q)),
					stack: "intakt",
				},
				{
					name: this.$t("Bokslutsdispositioner"),
					data: this.profitloss.sheets.map((s) => this.pos(s.O)),
					stack: "intakt",
				},
				{
					name: this.$t("Finansiella poster"),
					data: this.profitloss.sheets.map((s) => this.pos(s.LM)),
					stack: "intakt",
				},
				{
					name: this.$t("Av- och nedskrivningar"),
					data: this.profitloss.sheets.map((s) => this.pos(s.J)),
					stack: "intakt",
				},
				{
					name: this.$t("Övr. rörelsekostnader"),
					data: this.profitloss.sheets.map((s) => this.pos(s.H)),
					stack: "intakt",
				},
				{
					name: this.$t("Personalkostnader"),
					data: this.profitloss.sheets.map((s) => this.pos(s.G)),
					stack: "intakt",
				},
				{
					name: this.$t("Övr. externa kostnader"),
					data: this.profitloss.sheets.map((s) => this.pos(s.F)),
					stack: "intakt",
				},
				{
					name: this.$t("Kostnader för varor & material"),
					data: this.profitloss.sheets.map((s) => this.pos(s.D)),
					stack: "intakt",
				},
				{
					name: this.$t("Övriga rörelseintäkter"),
					data: this.profitloss.sheets.map((s) => this.pos(s.B)),
					stack: "intakt",
				},
				{
					name: this.$t("Nettoomsättning"),
					data: this.profitloss.sheets.map((s) => this.pos(s.A)),
					stack: "intakt",
				},
				{
					name: this.$t("Nettoomsättning"),
					data: this.profitloss.sheets.map((s) => this.neg(s.A)),
					stack: "kostnad",
				},
				{
					name: this.$t("Övriga rörelsintäkter"),
					data: this.profitloss.sheets.map((s) => this.neg(s.B)),
					stack: "kostnad",
				},
				{
					name: this.$t("Kostnader för varor & material"),
					data: this.profitloss.sheets.map((s) => this.neg(s.D)),
					stack: "kostnad",
				},
				{
					name: this.$t("Övr. externa kostnader"),
					data: this.profitloss.sheets.map((s) => this.neg(s.F)),
					stack: "kostnad",
				},
				{
					name: this.$t("Personalkostnader"),
					data: this.profitloss.sheets.map((s) => this.neg(s.G)),
					stack: "kostnad",
				},
				{
					name: this.$t("Övr. rörelsekostnader"),
					data: this.profitloss.sheets.map((s) => this.neg(s.H)),
					stack: "kostnad",
				},
				{
					name: this.$t("Av- och nedskrivningar"),
					data: this.profitloss.sheets.map((s) => this.neg(s.J)),
					stack: "kostnad",
				},
				{
					name: this.$t("Finansiella poster"),
					data: this.profitloss.sheets.map((s) => this.neg(s.LM)),
					stack: "kostnad",
				},
				{
					name: this.$t("Bokslutsdispositioner"),
					data: this.profitloss.sheets.map((s) => this.neg(s.O)),
					stack: "kostnad",
				},
				{
					name: this.$t("Skatt"),
					data: this.profitloss.sheets.map((s) => this.neg(s.Q)),
					stack: "kostnad",
				},
				{
					name: this.$t("Årets vinst"),
					data: this.profitloss.sheets.map((s) => this.pos(s.R)),
					stack: "kostnad",
				},
				{
					name: this.$t("Årets förlust"),
					data: this.profitloss.sheets.map((s) => (s.R < 0 ? s.R : 0)),
					stack: "intakt",
				},
			],
		});
	},
};
</script>

<style scoped lang="scss">
.dot {
	height: 20px;
	width: 20px;
	border-radius: 50%;
	display: inline-block;
}

.result {
	background: linear-gradient(
		-45deg,
		col("colors.Negative"),
		col("colors.Negative") 50%,
		col("colors.Positive") 50%
	);
	border-radius: 50%;
}

.center {
	font-size: 1.2rem;
}
</style>
